import Breadcrumbs from '@/themes/base/components/molecule/Breadcrumbs'

export default {
  extends: Breadcrumbs,
}
